module.exports = __webpack_public_path__ + "img/logo.ecd235368bda2ac019a2d5faadc0eb97.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo.svg
// module id = 803
// module chunks = 0